import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'projectState',
  standalone: true,
  pure: true
})
export class ProjectStatePipe implements PipeTransform {

  transform(state: string | null | undefined): {name: string, icon: string, class: string} {
    switch (state) {
      case 'NonValidated': {
        return {
          name: 'No validado',
          icon: 'close',
          class: 'subtle-red',
        }
      }
      case 'Validated': {
        return {
          name: 'Validado',
          icon: 'verified',
          class: 'subtle-purple',
        }
      }
      case 'Planning': {
        return {
          name: 'Planificación',
          icon: 'event_upcoming',
          class: 'subtle-pink',
        }
      }
      case 'InExecution': {
        return {
          name: 'En ejecución',
          icon: 'motion_play',
          class: 'subtle-blue',
        }
      }
      case 'PaymentStatus': {
        return {
          name: 'Estado de pago',
          icon: 'price_change',
          class: 'subtle-teal',
        }
      }
      case 'Finalized': {
        return {
          name: 'Finalizado',
          icon: 'check_circle',
          class: 'subtle-green',
        }
      }
      default: {
        return {
          name: 'Sin estado',
          icon: '',
          class: 'black',
        }
      }
    }
  }

}
